import { createContext } from "react";
import { UserState } from "./UserReducer";



export interface UserContextProps {
  state: UserState;
  dispatch: React.Dispatch<any>;
}

export const UserContext = createContext<UserContextProps | undefined>(undefined);
